<template>
  <div class="gc-ai-overlay-mount">
    <transition name="gc-ai-overlay-fade">
      <div
        v-if="visible"
        class="gc-ai-overlay"
        role="alertdialog"
        aria-modal="true"
        aria-live="polite"
        aria-busy="true"
        :aria-label="message"
        @click.self.prevent
        @mousedown.self.prevent
        @touchstart.self.prevent
      >
        <div class="gc-ai-overlay__backdrop" aria-hidden="true" />
        <div class="gc-ai-overlay__card" @click.stop @mousedown.stop>
          <div class="gc-ai-overlay__orb" aria-hidden="true">
            <span class="gc-ai-overlay__ring gc-ai-overlay__ring--1" />
            <span class="gc-ai-overlay__ring gc-ai-overlay__ring--2" />
            <span class="gc-ai-overlay__ring gc-ai-overlay__ring--3" />
            <span class="gc-ai-overlay__core">
              <v-icon color="#060f23" size="28">mdi-creation</v-icon>
            </span>
          </div>
          <p class="gc-ai-overlay__title">{{ message }}</p>
          <p v-if="detail" class="gc-ai-overlay__detail">{{ detail }}</p>
          <p v-if="statusLine" class="gc-ai-overlay__status">{{ statusLine }}</p>
          <div class="gc-ai-overlay__dots" aria-hidden="true">
            <span /><span /><span />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { translationStatusPhase } from '@/plugins/translation-progress';

const BODY_LOCK_CLASS = 'gc-ai-overlay-open';

export default {
  name: 'TranslationAiOverlay',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Translating…'
    },
    detail: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      elapsedSec: 0,
      tickId: null
    };
  },

  computed: {
    statusLine() {
      if (!this.visible || this.elapsedSec < 1) return '';
      const phase = translationStatusPhase(this.elapsedSec);
      return `${phase} · ${this.elapsedSec}s`;
    }
  },

  mounted() {
    this.portalToBody();
  },

  watch: {
    visible: {
      immediate: true,
      handler(active) {
        this.setBodyLock(active);
        if (active) {
          this.startTimer();
        } else {
          this.stopTimer();
        }
      }
    }
  },

  beforeDestroy() {
    this.stopTimer();
    this.setBodyLock(false);
    this.removePortal();
  },

  methods: {
    startTimer() {
      this.stopTimer();
      this.elapsedSec = 0;
      this.tickId = window.setInterval(() => {
        this.elapsedSec += 1;
      }, 1000);
    },

    stopTimer() {
      if (this.tickId != null) {
        window.clearInterval(this.tickId);
        this.tickId = null;
      }
      this.elapsedSec = 0;
    },

    portalToBody() {
      if (typeof document === 'undefined' || !this.$el) return;
      if (this.$el.parentNode !== document.body) {
        document.body.appendChild(this.$el);
      }
    },

    removePortal() {
      if (typeof document === 'undefined' || !this.$el?.parentNode) return;
      this.$el.parentNode.removeChild(this.$el);
    },

    setBodyLock(active) {
      if (typeof document === 'undefined') return;
      document.body.classList.toggle(BODY_LOCK_CLASS, Boolean(active));
    }
  }
};
</script>
